import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router"
import cx from "classnames"
import styles from "./index.module.css"
import { Container, Badge, BellIcon } from "@cividao/components"
import { useTranslation } from "react-i18next"
import { useLogos } from "../../../../hooks/useLogos"
import { useNotifications } from "../../../../state"

export const Topbar = () => {
  const { t } = useTranslation("common")
  const { logoFull } = useLogos()
  const { unreadCount } = useNotifications()
  const navigate = useNavigate()
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div className={cx(styles.container, { [styles.scrolled]: isScrolled })}>
      <Container>
        <div className={styles.innerContainer}>
          <Link to="/dashboard" viewTransition className={styles.logoLink}>
            <img src={logoFull} alt={t("logoAlt")} className={styles.logo} />
          </Link>
          <div className={styles.buttons}>
            <button className={styles.bellButton} onClick={() => navigate("/notifications")}>
              <BellIcon />
              {unreadCount > 0 && (
                <span className={styles.bellBadge}>
                  <Badge color="error" />
                </span>
              )}
            </button>
          </div>
        </div>
      </Container>
    </div>
  )
}
